var _path, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNotationStudioTab = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5967 11.3692C23.7447 9.6399 22.2811 8.67164 20.8652 7.73415C19.81 7.03462 18.8149 6.37407 18.1101 5.42838L17.9795 5.25401C17.5648 4.70218 17.0922 4.07651 17.0196 3.55135C16.9471 3.02003 16.5242 2.65078 15.923 2.66719C15.3798 2.70412 14.959 3.15132 14.959 3.69084V21.9688C14.0904 21.4478 13.0207 21.1277 11.8494 21.1277C8.99266 21.1277 6.66667 22.9678 6.66667 25.2305C6.66667 27.4932 8.99266 29.3333 11.8494 29.3333C14.7081 29.3333 17.0321 27.4932 17.0321 25.2305V13.275C18.5889 13.8637 21.1368 15.3633 21.8375 18.865C21.7069 19.0558 21.5825 19.263 21.4374 19.4251C21.058 19.8497 21.1015 20.498 21.5306 20.8713C21.9577 21.2488 22.6128 21.2036 22.9922 20.779C24.2899 19.3205 25.1834 17.0106 25.3223 14.752C25.3907 13.6381 25.1399 12.4688 24.5967 11.3692Z",
    fill: "var(--asset-gradient-id)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "notation-gradient-top",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--asset-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--asset-bg-color)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "notation-gradient-left",
    x1: 32,
    y1: 16,
    x2: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--asset-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--asset-bg-color)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotationStudioTab, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notation-studio-tab.30c396a1.svg";
export { ForwardRef as ReactComponent };